export default "__VITE_ASSET__fFM$LrsL__"